/**
 * Build stamp: d+{day}.{month}.{year} (dev) or p+{day}.{month}.{year} (prod).
 * Production date is frozen at compile time via REACT_APP_BUILD_DATE (set in npm run build).
 */

function formatDateParts(date) {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return null;
  const day = d.getDate();
  const month = d.getMonth() + 1;
  const year = d.getFullYear() % 100;
  return `${day}.${month}.${year}`;
}

function parseBuildDateEnv(raw) {
  const s = String(raw || '').trim();
  if (!s) return null;
  if (/^\d{1,2}\.\d{1,2}\.\d{1,2}$/.test(s)) return s;
  const parsed = formatDateParts(new Date(s));
  return parsed;
}

export function getAppVersionLabel() {
  const isProduction = process.env.NODE_ENV === 'production';
  const prefix = isProduction ? 'p+' : 'd+';

  const fromEnv = parseBuildDateEnv(process.env.REACT_APP_BUILD_DATE);
  const datePart = fromEnv || formatDateParts(new Date());

  return `${prefix}${datePart}`;
}
